import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track15ARed = ({ state, workState, onLabelClick }) => (
	<g id="Track15ARed" transform="translate(2147.500000, 922.707387)" className="track">
		<path d="M59.826702,78.8617362 L18.5432701,25.3976824 M11.9045719,16.6467527 L3.87245791e-13,2.13162821e-14"
					stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
					strokeWidth={tracksWidth} strokeLinecap="round"/>

		<TrackArrow
			transform="translate(20.304186, 27.628604) rotate(-308.000000) translate(-20.304186, -27.628604) "
			points="24.3041863 35.6286037 16.3041863 27.6286037 24.3041863 19.6286037"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track15ARed')}
			coords="27.500000, 36.347300"
			text="15A"
			textCoordsX="7.30957031"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track15ARed.propTypes = trackPropTypes;

export default Track15ARed;
